import React, { FC, useState }         from "react";
import { useDispatch }                 from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteStaff                     from "../../../application/usecase/staff/DeleteStaff";
import Staff                           from "../../../domain/staff/Staff";

interface Props {
  staff: Staff;
}

const StaffDeleteButton: FC<Props> = (props: Props) => {
  const {staff} = props;
  const [open, setOpen] = useState(false);
  const deleteStaff: DeleteStaff = new DeleteStaff(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        negative
        onClick={ () => setOpen(true) }
      >
        <Icon name="trash"/>削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>スタッフ削除の確認</Modal.Header>
        <Modal.Content>
          <Header
            as="h5"
            icon="info circle"
            dividing
            content={ `スタッフ ${ staff.name.lastName.value } ${ staff.name.firstName.value } を削除します。` }
            color="red"
          />
          <Modal.Description>
            <p>よろしいですか？</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              deleteStaff.execute(staff.id);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default StaffDeleteButton;
